import React from 'react';
import { SectionProps } from './types';

function UnknownSection(_: SectionProps) {
  return (
    <div className="border border-ui-red rounded px-6 text-ui-red py-4">
      You're seeing this message because you have forgot to define a section properly in your service
    </div>
  );
}

export { UnknownSection };
